import { render, staticRenderFns } from "./OtherResources.vue?vue&type=template&id=4e4c3a64&"
import script from "./OtherResources.vue?vue&type=script&lang=js&"
export * from "./OtherResources.vue?vue&type=script&lang=js&"
import style0 from "./OtherResources.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports